import React, {useState, useEffect} from "react";
import { rhythm, scale } from "../utils/typography";
import ReactHtmlParser from "react-html-parser";
import Block from "./blocksDescriptionComponents";
import Img from "gatsby-image";


const BlocksDescription = (props) => {

    const [activeAnimation,setActiveAnimation] = useState(false);
    
    useEffect(() => {
        
        if(typeof window !== "undefined"){
            
            
            const triggerAnimation = () =>{
              
                if(window.scrollY >= 800){
                    console.log("activando animacion");
                    setActiveAnimation(true);
                    window.removeEventListener("scroll",triggerAnimation);
                 }
            }

            window.addEventListener("scroll",triggerAnimation);
        }
    }, []); 

    const blocksDescription = props;
    console.log("probando blockDescription ",props);


  return (
      <>
        <Block>
            <div className="list">
                {blocksDescription.sections.right.map((i, k) => {
                    return (
                        <div key={k} className={`item ${activeAnimation ? "animation-up-to-down" : ""}`}>
                            {ReactHtmlParser(i.content)}
                        </div>
                    );
                })}
            </div>
      </Block>
    </>
  );
};

export default BlocksDescription;
